module.exports = __webpack_public_path__ + "static/img/ios1.99f72e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/offcn-teacher-downloads/ios1.png
// module id = qGGA
// module chunks = 1